import ContentSection from '@/components/ContentSection';
import { entryPoint } from 'react_rails/entryPoint';
import { PhotoGalleryContainer, PhotoGalleryProps } from 'containers/PhotoGalleryContainer';
import PhotoGalleryHeader from 'containers/PhotoGalleryContainer/components/PhotoGalleryHeader';
import PhotoGalleryControls from 'containers/PhotoGalleryContainer/components/PhotoGalleryControls';
import PhotoGalleryRowAlbum from 'containers/PhotoGalleryContainer/components/PhotoGalleryRowAlbum';
import PageSection from '@/components/PageSection';
import { ScreenSize } from '@/components/ScreenSizes';
import Header from 'components/Header';
import Footer from 'components/Footer';

export default entryPoint(function Index({ ...props }: PhotoGalleryProps) {
  return (
    <PhotoGalleryContainer {...props}>
      <Header />
      <PhotoGalleryHeader />
      <PageSection flush={ScreenSize.SMALL}>
        <ContentSection>
          <PhotoGalleryControls />
          <PhotoGalleryRowAlbum />
        </ContentSection>
      </PageSection>
      <Footer />
    </PhotoGalleryContainer>
  );
});
